'use client'
import { useState } from 'react'

import { Categories } from './categories'
import { CategoryTabs } from './category-tabs'

export function Wrapper() {
  const [categoryId, setCategoryId] = useState<string>('utilities')

  const handleCategoryChange = (categoryId: string) => {
    if (categoryId) setCategoryId(categoryId)
  }

  return (
    <div className="space-y-10">
      <Categories />
      <CategoryTabs
        selectedTab={categoryId}
        onSelectTab={handleCategoryChange}
      />
    </div>
  )
}
